import { useState } from "react";
import { useTranslation } from "react-i18next";
import { faqData } from "@/mocks/categories";

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="text-accent-600 text-base">&#9670;</span>
            <span className="text-xs md:text-sm font-semibold text-foreground-500 uppercase tracking-wider">
              {t("faq.title")}
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-3">
            {t("faq.subtitle")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t("faq.description")}
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-background-200/70 bg-background-100/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <span className={`w-6 h-6 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? "rotate-45" : ""}`}>
                  <i className="ri-add-line text-sm"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === idx ? "max-h-60 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <p className="px-5 md:px-6 pb-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}